export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
>
  <g
    transform="matrix(0.01691762,0,0,0.01757812,-0.57537068,9.7656292e-6)"
  >
    <path
      d="M 379.027,658.586 995.798,19.959 c 0,0 49.778,-44.909 92.277,0 34.003,35.2 -30.365,121.407 -30.365,121.407 L 502.856,931.76 c 0,0 -53.418,83.78 -92.277,91.051 -44.909,8.502 -64.356,-30.365 -92.277,-60.72 C 289.17,931.726 40.259,597.865 40.259,597.865 c 0,0 -26.726,-71.629 30.365,-121.407 58.28,-49.778 123.842,0 123.842,0 l 184.535,182.124 z"
    />
  </g>
</svg>`;
